(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
  $(".faqs > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".faq_content")
        .slideUp(200);
      $(".faqs > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".faqs > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".faqs > a").removeClass("active");
      $(this).addClass("active");
      $(".faq_content").slideUp(200);
      $(this)
        .siblings(".faq_content")
        .slideDown(200);
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
